import {
  ToothMPRSliceOptions,
  ToothMPRSliceOptions_SeriesOptions,
} from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

import type { ToothMPRSliceOptionsUpdate } from '../config';

export const applyPendingToothMPRSliceOptions = ({
  options,
  pendingUpdates = [],
}: {
  options: ToothMPRSliceOptions | null;
  pendingUpdates?: ToothMPRSliceOptionsUpdate[];
}): ToothMPRSliceOptions | null => {
  if (!pendingUpdates.length) {
    return options;
  }

  return new ToothMPRSliceOptions(
    pendingUpdates.reduce(
      (current, update) => ({
        ...current,
        [update.series]: new ToothMPRSliceOptions_SeriesOptions(update.options),
      }),
      {
        Axial: options?.Axial,
        VestibuloOral: options?.VestibuloOral,
        MesioDistal: options?.MesioDistal,
      },
    ),
  );
};
